import type { CSSProperties, ReactNode } from "react";

type RuntimeAspectRatioAttributes = { style: CSSProperties };

interface RuntimeAspectRatioProps {
  aspectRatio?: number;
  children: (attributes: RuntimeAspectRatioAttributes) => ReactNode;
}

/** Applies intrinsic media geometry calculated from runtime metadata. */
export function RuntimeAspectRatio({ aspectRatio, children }: RuntimeAspectRatioProps): ReactNode {
  return children({ style: { aspectRatio } });
}
